import React from 'react'
import { DashboardContainer } from './style'
import InvoicesWidget from './widgets/InvoicesWidget'
import MilkPriceWidget from './widgets/MilkPriceWidget'
import MilkQualityWidget from './widgets/MilkQualityWidget'
import MilkAmountWidget from './widgets/MilkAmountWidget'
import AktuellesWidget from './widgets/NewsWidget'
import { buildNewsData } from './mockData'
import { MilkMoneyProvider } from './MilkMoneyContext'
import MilkMoneyFilters from './MilkMoneyFilters'
import { useTranslation } from 'react-i18next'

const NewsWidgetWithContext: React.FC = () => {
  const { i18n } = useTranslation()
  const lang = i18n.language.startsWith('fr') ? 'fr' : 'de'
  return <AktuellesWidget data={buildNewsData(lang)} />
}

const MoohDashboard: React.FC = () => {
  return (
    <MilkMoneyProvider>
      <div style={{ marginTop: '1em' }}>
        <MilkMoneyFilters />
        <DashboardContainer>
          <MilkPriceWidget />
          <InvoicesWidget />
          <MilkQualityWidget />
          <MilkAmountWidget />
          <NewsWidgetWithContext />
        </DashboardContainer>
      </div>
    </MilkMoneyProvider>
  )
}

export default MoohDashboard
